import { render, staticRenderFns } from "./createSpvNode.vue?vue&type=template&id=527d6d33&scoped=true&"
import script from "./createSpvNode.vue?vue&type=script&lang=js&"
export * from "./createSpvNode.vue?vue&type=script&lang=js&"
import style0 from "./createSpvNode.vue?vue&type=style&index=0&id=527d6d33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d6d33",
  null
  
)

export default component.exports